import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getMyFavourites, resetField } from "../../store/actions";
import RecipesCard from "../nutrition/recipes/listing/recipesCard";
import NoContent from "../../sharedComponents/noItemFoundAlert";

const MyFavourites = ({ getMyFavourites, favoriteRecipes, history, resetField }) => {
	useEffect(() => {
		getMyFavourites();
	}, [getMyFavourites]);

	useEffect(() => {
		return () => {
			resetField("Recipes.favoriteRecipes", []);
		};
	}, [resetField]);

	return (
		<section className="page page-food-details">
			<div className="container">
				<h3> My Favorites</h3>
				<div className="card-wrap">
					{favoriteRecipes && favoriteRecipes.length ? (
						favoriteRecipes.map((card, i) => <RecipesCard key={i} history={history} cardInfo={card} />)
					) : (
						<div className="px-3 w-100">
							<NoContent />
						</div>
					)}
				</div>
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { Recipes } = state;
	return {
		favoriteRecipes: get(Recipes, "favoriteRecipes", [])
	};
};

const mapDispatchToProps = {
	getMyFavourites,
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MyFavourites);
